import React from 'react';

const Splash=()=>{
    return (
        <div className='Splash'>
            <img src='/logo_puma.png' alt='Logo' className='splash-logo'/>
        </div>
    );
};

export default Splash;
